import HBIcon from "@/components/HBIcon";
import HBMessage from "@/components/HBMessage";
import { useLogin } from "@/components/LoginModal";
import { BuyVipDialog } from "@/components/Vip";
import { getPin } from "@/services";
import { handleDownload } from "@/utils/download";
import { Button } from "antd";
import { useCallback, useRef, useState } from "react";
import styles from "./index.module.less";

/**
 * 素材下载
 * */
export default function PinDownload({ pin, user, vips, refreshVips }) {
  const downloadDialogRef = useRef(null);
  const { login } = useLogin();
  const [loading, setLoading] = useState(false);
  const pinId = pin?.pin_id;

  const onClick = useCallback(async () => {
    let isVip = vips.length > 0;
    if (!user) {
      const result = await login();
      if (!result) {
        return;
      }
      const vipResult = await refreshVips();
      isVip = vipResult.some((vip) => !vip.is_expired);
    }

    if (!isVip) {
      BuyVipDialog.open();
      return;
    }

    if (!pinId) {
      return;
    }

    setLoading(true);
    const result = await getPin({
      pin_id: pinId,
      pins: 0,
      ignoreMessage: false,
    });

    // 获取采集失败
    if (result?.err) {
      HBMessage.error("当前素材无法被下载");
      setLoading(false);
      return;
    }

    const pin = result?.pin;

    const info = pin?.material_info;
    const material = pin?.file_material;

    // 判断素材详情信息是否存在
    if (!material || material?.err === 404) {
      HBMessage.error("当前素材无法被下载");
      setLoading(false);
      return;
    }

    // 获取file信息
    let file = null;
    if (material?.material_category === "视频") {
      const mps = info?.content?.mps?.find((mps) => {
        return mps.name === "HD";
      });
      if (mps) {
        file = {
          file_format: mps.file_format,
          file_size: mps.file_size,
          file_type: mps.name,
        };
      }
    } else {
      file = info?.files?.find((file) => file.file_type === "ORIGIN") || null;
    }

    if (!file) {
      HBMessage.error("当前素材无法被下载");
      setLoading(false);
      return;
    }

    // 调用下载方法
    await handleDownload(pin, file);
    setLoading(false);
  }, [login, pinId, refreshVips, user, vips]);

  // 判断是否是素材、素材状态、素材类型
  if (
    pin?.file_material?.status === 2 &&
    pin?.file_material?.material_category !== "其他"
  ) {
    // 判断是否登录，判断是否是会员
    if (user && vips.length > 0) {
      return (
        <Button
          className={styles.download}
          icon={<HBIcon type="ic_other" />}
          loading={loading}
          data-gd-click="button_click"
          data-button-name="素材卡片-下载"
          onClick={onClick}
        >
          下载
        </Button>
      );
    }
    // 未登录或者不是会员的现在获取商业授权按钮
    return (
      <Button
        className={styles.download}
        data-gd-click="button_click"
        data-button-name="素材卡片-获取商业授权"
        onClick={onClick}
      >
        获取商业授权
      </Button>
    );
  }

  return null;
}
